import { boltApi } from 'store/queries/bolt-api'
import { GetReferralCodePayload, GetReferralCodeResponse } from './types.ts'
import { Methods } from 'types/request.ts'
import { Flow } from 'types/logging.ts'
import { createErrorTransformer } from 'store/queries/utils.ts'

export const customersBoltApi = boltApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET REFERRAL CODE
    getReferralCode: builder.query<GetReferralCodeResponse, GetReferralCodePayload>({
      query: ({ email }) => ({
        method: Methods.GET,
        url: `customers/referral-code?email=${encodeURIComponent(email)}`
      }),
      transformResponse: ({ data }) => {
        return data
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.CUSTOMERS}:getReferralCode]`)
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetReferralCodeQuery } = customersBoltApi
